import { Link } from "react-router-dom";
import { XCircle, ArrowLeft } from "lucide-react";
import Navbar from "../components/lac/Navbar";
import Footer from "../components/lac/Footer";

export default function BookingCancel() {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />
      <div className="max-w-xl mx-auto px-6 pt-40 pb-32 text-center" data-testid="booking-cancel-page">
        <div className="w-20 h-20 mx-auto rounded-full bg-red-500/10 border border-red-500/40 flex items-center justify-center">
          <XCircle className="w-10 h-10 text-red-400" strokeWidth={2} />
        </div>
        <h1 className="mt-8 font-display font-bold text-3xl tracking-tighter">Booking not completed</h1>
        <p className="mt-4 text-zinc-400 font-body">
          You closed the payment screen before finishing — no charge has been made and no slot is held.
          Want to try again?
        </p>
        <div className="mt-10 flex justify-center gap-3">
          <Link to="/booking" data-testid="cancel-retry-btn" className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-[#D946EF] text-white font-semibold hover:bg-[#F0ABFC] transition">
            <ArrowLeft className="w-4 h-4" /> Back to booking
          </Link>
          <a href="https://wa.me/447538963090" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-white/15 text-white hover:border-[#25D366] hover:text-[#25D366] transition">
            WhatsApp us instead
          </a>
        </div>
      </div>
      <Footer />
    </div>
  );
}
